import { useState, useEffect } from 'react';

const ADMIN_DASHBOARD_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5000/v1/admin/dashboard'
  : '/v1/admin/dashboard';

export default function useAdminData() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    fetch(ADMIN_DASHBOARD_URL)
      .then(r => {
        if (!r.ok) throw new Error(`Server error ${r.status}`);
        return r.json();
      })
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  return { data, loading, error };
}
